import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import NorthEastIcon from "@mui/icons-material/NorthEast";
import { motion } from "framer-motion";
import { talent } from "../../../../utils/siteContent";
import { getIcon } from "../../../../utils/iconMap";
import { revealProps } from "../../../../utils/motion";
import Reveal from "../../../commons/reveal/reveal";
import { StyledLayout } from "../../../styled/layout";
import { StyledTalent } from "../../../styled/talent";

const MotionCard = motion(StyledTalent.Card);

const Talent = () => (
  <StyledTalent.Root id="talento">
    <StyledTalent.Bg aria-hidden="true">
      <StyledTalent.Blob variant={1} />
      <StyledTalent.Blob variant={2} />
    </StyledTalent.Bg>

    <StyledLayout.Container>
      <StyledTalent.Inner>
        <Reveal>
          <StyledTalent.Head>
            <StyledLayout.Tag
              style={{
                color: "#8AC2EC",
                background: "rgba(75,163,224,0.12)",
                borderColor: "rgba(75,163,224,0.25)",
              }}>
              Talento
            </StyledLayout.Tag>
            <StyledLayout.Title style={{ color: "#fff" }}>
              Personas creando tecnología{" "}
              <StyledLayout.GradientText>para personas</StyledLayout.GradientText>
            </StyledLayout.Title>
            <StyledLayout.Lead style={{ color: "rgba(255,255,255,0.72)" }}>
              {talent.intro}
            </StyledLayout.Lead>

            <StyledTalent.Badge>
              <EmojiEventsIcon /> {talent.badge}
            </StyledTalent.Badge>

            <StyledTalent.CtaWrap>
              <StyledLayout.Button href="#contacto" variant="light">
                Enviá tu CV <NorthEastIcon />
              </StyledLayout.Button>
            </StyledTalent.CtaWrap>
          </StyledTalent.Head>
        </Reveal>

        <StyledTalent.Grid>
          {talent.items.map((t, i) => {
            const Icon = getIcon(t.icon);
            return (
              <MotionCard key={t.title} {...revealProps(i * 0.08)}>
                <div className="talent-icon">
                  <Icon />
                </div>
                <h4>{t.title}</h4>
                <p>{t.text}</p>
              </MotionCard>
            );
          })}
        </StyledTalent.Grid>
      </StyledTalent.Inner>
    </StyledLayout.Container>
  </StyledTalent.Root>
);

export default Talent;
